module.exports = __webpack_public_path__ + "img/cabinet_retrofit.d79ce1af.svg";